<div class="inline underline cursor-pointer pos-relative"
     (mouseenter)="showTooltip()"
     (mouseleave)="hideTooltip()">
    <price class="col-1"
           [sizeClass]="'!SM:s3,SM:s4'"
           [value]="financeFrom"
           [precision]="2" />
    <span class="col-1"
          [sizeClass]="'!SM:p3,SM:p4'">&nbsp;{{ 'p/m with low deposit credit*' | translate }}</span>
    <div class="_tooltip c2" [class.visually-hidden]="!isTooltipVisible">
        {{'*Finance is subject to affordability, age and status- minimum spend applies.' | translate}}
    </div>
</div>
